import * as React from 'react'
import IcoMoon from '@src/components/common/ico.moon'
import type { ResourceTypeDict, ResourceType } from '@src/redux/reducers/shell'
import type {
  ExtCellInfo,
  ColumnProps
} from '../models/column.props.configuration'
import Tooltip from '@mui/material/Tooltip'

export interface IconGraphProps<T> {
  row: ExtCellInfo<T>
  column: ColumnProps<T>
  resourceTypes: ResourceTypeDict
}

interface RowOriginal {
  type?: string
}

function IconGraph<T extends RowOriginal>({
  row,
  column,
  resourceTypes
}: IconGraphProps<T>): React.ReactElement<IconGraphProps<T>> {
  const { original } = row
  const iconName = original[column.field]
  if (!iconName) return null
  const { colorHash, imageHash, display_name } = (resourceTypes[
    String(iconName)
  ] || {}) as ResourceType
  return (
    <Tooltip title={display_name}>
      <IcoMoon
        iconHash={imageHash}
        iconColor={colorHash}
        styles={'font-size: 26px;'}
      />
    </Tooltip>
  )
}

export default IconGraph
